const styles = {
  root: {
    position: 'relative',
    width: '100%',
    height: '90vh',
  },
  pin: {
    position: 'relative',
    height: 40,
    width: 40,
    borderRadius: 20,
    border: 2,
    borderColor: 'text.white',
    transition: 'all 0.5s ease',
    '& img': {
      borderRadius: 20,
    },
    '&:hover': {
      transform: 'scale(1.2)!important',
      borderRadius: 20,
    },
  },

  degradeContainer: {
    width: '100%',
    height: 120,
    top: 0,
    zIndex: 99,
    position: 'absolute',
    background: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 90%, rgba(255,255,255,1) 100%);',
  },

  imageContainer: {
    display: { xs: 'none', lg: 'block' },
    position: 'absolute',
    height: 200,
    width: 200,
    bottom: 140,
    left: 100,
  },

  image: {
    position: 'relative',
    height: 200,
    width: 200,
  },

  modalFilterContainer: {
    '& .MuiDialog-paper': {
      borderRadius: { xs: '0px!important', lg: '4px!important' },
      width: { md: 500 },
      minHeight: { md: 'calc(100vh - 100px)' },
    },
    '& .MuiDialogContent-root': {
      paddingBottom: '0px!important',
    },
  },
}

export default styles
